import { create } from "zustand";
import { api, ApiError } from "../utils/api.js";
import type { User } from "@/shared/types.js";

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  authenticated: boolean;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  error: null,
  authenticated: false,
  fetchUser: async () => {
    try {
      const user = await api.get<User>("/users/me");
      set({ user, loading: false, error: null, authenticated: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        set({ user: null, loading: false, error: null, authenticated: false });
      } else {
        set({ user: null, loading: false, error: String(err), authenticated: false });
      }
    }
  },
  logout: async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // best-effort
    }
    set({ user: null, authenticated: false });
    window.location.href = "/";
  },
}));
